import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">精选专题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            精心策划的影视专题合集，发现更多好片
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardItems.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-500/40 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/80 backdrop-blur-sm text-xs font-medium text-foreground-800 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 mt-2 line-clamp-2">{item.description}</p>
                <div className="flex items-center gap-2 mt-3">
                  <span className="text-xs text-primary-500 font-medium whitespace-nowrap">{item.count}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
          {cardItems.slice(3, 5).map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-500/40 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative sm:w-48 flex-shrink-0 aspect-video sm:aspect-auto overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col justify-center flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-full bg-accent-500/15 text-xs font-medium text-accent-600 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 mt-1.5 line-clamp-2">{item.description}</p>
                <span className="text-xs text-primary-500 font-medium mt-2 whitespace-nowrap">{item.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}